<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex flex-column flex-md-row align-items-start justify-content-md-between">
        <div class="mb-0">
          <h1 class="page-title">Propriétaires</h1>
          <h2 class="page-subtitle">Total : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" class="text-nowrap">
          <plus-icon size="18" class="mr-1" /> Ajouter un propriétaire
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableUser"
          identifier="B122TableUser"
          init-b122-table-url="/user/initB122Table"
          get-b122-table-results-url="/user/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >

          <template #cell(username)="data">
            <b-link :href="'mailto:'+data.value">{{data.value}}</b-link>
          </template>

          <template #cell(animals)="data">
            <template  v-for="(animal, index) in data.item.animals">
              <template v-if="index > 0">, </template>
              <b-link :to="{name: 'AnimalShow', params: {animalId: animal.id }}">{{animal.name}}</b-link>
            </template>
          </template>

        </b122-table>

      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <user-delete-modal :selectedUser="ui.selectedUser" @didDeleteUser="didDeleteUser()"></user-delete-modal>

  </div>

</template>

<script>

import B122Table from "../../components/b122/B122Table";
import UserDeleteModal from "./UserDeleteModal";

export default {

  name: 'UserIndex',

  components: {
    B122Table,
    UserDeleteModal
  },

  data() {
    return {

      totalCount: 0,

      tableFields: [
        {
          label: "",
            key: "show",
            sortable: false
        },
        {
          label: "Nom",
          key: "lastName",
          sortable: true
        },
        {
          label: "Prénom",
          key: "firstName",
          sortable: true
        },
        {
          label: "Email",
          key: "username",
          sortable: true,
        },
        {
          label: "Téléphone",
          key: "phone",
          sortable: false,
            formatter: function (value, key, item) {
                if (value) {
                    return value
                }
                return "-"
            }
        },
        {
          label: "Téléphone conjoint(e)",
          key: "secondPhone",
          sortable: false,
            formatter: function (value, key, item) {
                if (value) {
                    return value
                }
                return "-"
            }
        },
        {
          label: "Animaux",
          key: "animals",
          sortable: false,
            formatter: function (value, key, item) {
                if (value.length > 0) {
                  return value
                }
                return "-"
            }
        },
        {
          label: '',
          key: 'actions'
        }
      ],

      ui: {
        selectedUser: null
      }
    }
  },

  methods: {

      setTotalCount(totalCount) {
          this.totalCount = totalCount
      },

      clickOnCreateBtn() {
          this.$router.push({
              name: 'UserCreate'
          })
      },

      clickOnShowBtn(row) {
          this.$router.push({
              name: 'UserShow',
              params: {
                  userId: row.item.id
              }
          })
      },

      clickOnEditBtn(row) {
          this.$router.push({
              name: 'UserEdit',
              params: {
                  userId: row.item.id
              }
          })
      },

    clickOnDeleteBtn(row) {
      this.ui.selectedUser = row.item
      this.$bvModal.show('user-delete-modal')
    },

    didDeleteUser() {
      this.ui.selectedUser = null;
      this.$refs.B122TableUser.refreshTable()
    }
  },


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserIndex.vue